import React from 'react';
import * as styles from './aiEngineerFellowship.module.scss';
import { SOUMYA_MUKHERJEE_PHOTO, DEEPAK_SHARMA_PHOTO } from './mentorPhotos';

// Mentor bios/roles come from YAML; photos are large base64 assets that stay
// in their own JS file, matched back to each mentor by the YAML `id` field.
const MENTOR_PHOTOS = {
  soumya: SOUMYA_MUKHERJEE_PHOTO,
  deepak: DEEPAK_SHARMA_PHOTO,
};

const Mentors = ({ mentors, how }) => {
  return (
    <section id="mentors">
      <div className={styles.wrap}>
        <div className={styles.shead}>
          <h2>Learn From Industry Experts</h2>
          <p>
            Your mentors are shipping LLM, GenAI and agentic systems at product companies —
            teaching the live sessions and guiding your builds.
          </p>
        </div>
        <div className={styles.mentors}>
          {/* TODO: add 2–4 more mentors / reviewers. Do NOT add employer names or LinkedIn links. */}
          {mentors.map((mentor) => (
            <div className={styles.mentor} key={mentor.name}>
              <div className={`${styles.ava} ${styles.ph}`}>
                <img
                  src={MENTOR_PHOTOS[mentor.id]}
                  alt={mentor.name}
                  width={96}
                  height={96}
                  loading="lazy"
                />
              </div>
              <div>
                <h4>{mentor.name}</h4>
                <div className={styles.mrole}>{mentor.role}</div>
                <p>{mentor.bio}</p>
              </div>
            </div>
          ))}
        </div>
        <div className={styles.mhow}>
          {how.map((item) => (
            <div key={item.h}>
              <b>{item.h}</b>
              {item.p}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Mentors;
